import { IRemarkableBlockExtension } from '../types';

class HeadingToken {
  _content: { level: number; text: string; id?: string };

  get content() {
    return JSON.stringify(this._content);
  }

  type = 'heading';

  constructor(
    content: { level: number; text: string; id?: string },
    public level: number,
  ) {
    this._content = content;
  }
}

const name = 'heading';

export const headerExtension: IRemarkableBlockExtension = {
  name,
  parser(state, startLine, endLine, silent) {
    const line = state.getLines(startLine, startLine + 1, 0, false);
    const result = line.match(/(#+) ([^\{\n]+)(?:\{: #([^\}]+?) *\})?/);
    if (!result) return false;

    const level = result[1].length;
    const text = result[2];
    const id = (result[3] ?? result[2]).replaceAll(/\s+/g, '-');

    if (!silent)
      state.tokens.push(new HeadingToken({ level, text, id }, state.level));

    state.line += 1;
    return true;
  },
  replacer: (md) => (tokens, idx) => {
    const token = tokens[idx] as HeadingToken;
    const tag = `h${token._content.level}`;
    return `<${tag} ${
      token._content.id ? `id="${token._content.id.toLowerCase()}"` : ''
    }>${md.renderInline(token._content.text)}</${tag}>`;
  },
  styles() {
    return '';
  },
};
